import * as utils from './utils';
import * as utils_auth from './utils_auth';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { StoryUser } from './StoryUser';
import { Story } from './Story';
import { CloudinaryResult } from './Cloudinary';
import { globalUC } from './UserCache'

import settings from './settings.json';

let cloudinaryWidget: any = null
let wasSuccess: boolean = null

export enum photoType { profilePic = 0, storyComment }
const folderNames = ['storyhomeProfilePics', 'storyhomePhotos']
async function createCloudinaryWidget(v: Vue, type: photoType, storyId: string, commentText: string, successCallback: (result: CloudinaryResult) => void, errorCallback: () => void, abortCallback: () => void): Promise<void> {
  wasSuccess = null
  try {
    // @ts-ignore:
    await Vue.loadScript("https://widget.cloudinary.com/v2.0/global/all.js");
    console.log('Loaded external cloudinary script')

    // @ts-ignore: because cloudinary is inside injected script
    cloudinaryWidget = cloudinary.createUploadWidget({
      // can play with styles here - https://demo.cloudinary.com/uw/#/
      styles: {
        palette: {
            window: "#10173a",
            sourceBg: "#20304b",
            windowBorder: "#7171D0",
            tabIcon: "#79F7FF",
            inactiveTabIcon: "#8E9FBF",
            menuIcons: "#CCE8FF",
            link: "#72F1FF",
            action: "#5333FF",
            inProgress: "#00ffcc",
            complete: "#33ff00",
            error: "#cc3333",
            textDark: "#000000",
            textLight: "#ffffff"
        },
        fonts: {
            'default': null,
            "'Poppins', sans-serif": {
                url: "https://fonts.googleapis.com/css?family=IBM+Plex+Sans",
                active: true
            }
        }
      },

      cloudName: 'storyhome',
      uploadPreset: 'etoftigp',
      folder: folderNames[type],
      multiple: false,
      resourceType: 'image',
      clientAllowedFormats: [ 'jpeg', 'png', 'gif' ],
      // cropping: type === photoType.profilePic,         // cloudinary's cropping buttons are misleading so not sure it's worth confusing them
      // croppingCoordinatesMode: 'face',
      // sources: [],

    }, async (error, result: CloudinaryResult) => {
      console.log(`Got result.event===${result.event}`)
      if (!error && result && result.event === "success") {
        console.log('Done! Here is the image info: ', result);

        // post full result object to our server to handle, along with type, userId and storyId
        if (type === photoType.profilePic) {
          const url: string = utils.getURLprefix() + '/api/pictures';
          const response: any = await utils.makePostCall(url, { type, storyId, commentText, cloudinaryResult: result} );
          if (!response || !response.data) throw(new Error('utils_cloudinary got null response or null response.data'))
          if (response.data.error) {
            utils.toast(v, 'Error', response.data.error)
            if (errorCallback) errorCallback()
            wasSuccess = false
            console.log('Error on photo upload')
            return
          }

          if (response.data.user) {
            // success
            const user: StoryUser = new StoryUser(response.data.user)
            user.updateMeToCacheStoreAndLocalStorage()
            wasSuccess = true
            if (successCallback) successCallback(result)
            console.log('Success on photo upload')
          }
        }

        if (type === photoType.storyComment) {
          // success
          wasSuccess = true
          if (successCallback) successCallback(result)
          console.log('Success on photo upload')
        }
      } else if (!error && result && result.event === "close") {
        if (wasSuccess === null) {
          console.log('Aborted photo upload')
          if (abortCallback) abortCallback()
        }
      } else {
      }
    })

    // console.dir(cloudinaryWidget)

  } catch (error) {
    // Failed to fetch script
    console.log('Could not load external cloudinary script')
    if (errorCallback) errorCallback()
    wasSuccess = false
    console.log('Error on photo upload')
    return null

  }
}

export async function uploadPhoto(v: Vue, type: photoType, storyId: string, commentText: string, successCallback: (result: CloudinaryResult) => void, errorCallback: () => void, abortCallback: () => void): Promise<void> {
  await createCloudinaryWidget(v, type, storyId, commentText, successCallback, errorCallback, abortCallback)
  cloudinaryWidget.open()
}

// q_auto: https://cloudinary.com/documentation/image_transformations#automatic_quality_and_encoding_settings
// f_auto: choose best format based on web browser (usually jpeg, webp or png)
// w_xxx and h_xxx are used to resize image; w_iw and h_ih set to original widths and heights, useful when applying chained transformations
// c_zzzzz specifies how the resizing is done (e.g. scale, fit, limit, crop, thumb) -- i see myself using fit for profile pics and limit for story comment pics
// when using c_crop:
//  x_xxx and y_xxx are used in conjunction with w_xxx and h_yyy to specify the 4 coords
//  g_zzzzz specifies gravity (e.g. g_face and g_faces for auto face detection, g_custom for what user chose; can also do custom:face which choose custom if exists then face if not)
// dpr_xxxx might be interesting
export function getURL(type: photoType, public_id: string, fullsize?: boolean): string {
  const baseTransformations: string = 'c_crop,g_custom/f_auto,q_auto'
  let moreTransformations: string = type === photoType.profilePic ? ',w_128,h_128,c_fill,g_auto' : ',w_400,c_limit'
  if (fullsize) moreTransformations = ''
  return `https://res.cloudinary.com/storyhome/image/upload/${baseTransformations}${moreTransformations}/${public_id}`
}

export function getThumbnailURL(public_id: string): string {
  const baseTransformations: string = 'c_crop,g_custom/f_auto,q_auto'
  const moreTransformations: string = ',h_32,c_limit'
  return `https://res.cloudinary.com/storyhome/image/upload/${baseTransformations}${moreTransformations}/${public_id}`
}

(async () => {
})()
